/* Noorns redesign: the watch page player (sections/noorns-watch.liquid). The mockup's
   watch.js, plus one step first: transcript headings written "m:ss Title" in the page body get
   their time as a seek link, as the mockup printed them. */
(function () {
  var tb = document.getElementById('watch-transcript-body');
  if (!tb) return;
  var n = 0;
  tb.querySelectorAll('h3').forEach(function (h) {
    var m = (h.textContent || '').trim().match(/^(\d+):(\d\d)\s+(.*)$/);
    if (!m) return;
    n += 1;
    var t = parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
    h.id = 'transcript-' + n;
    h.textContent = m[3];
    var a = document.createElement('a');
    a.href = '?t=' + t; a.setAttribute('data-t', t); a.setAttribute('aria-label', 'Play from ' + m[1] + ':' + m[2]);
    a.textContent = m[1] + ':' + m[2];
    h.insertBefore(a, h.firstChild);
  });
})();
// Watch page player. The real YouTube player is in the page from the start, because Google says
// "Don't rely on user actions (such as swiping, clicking, or typing) to load the video."
// This script adds: chapter and transcript times that seek, ?t=<seconds> deep links (the address
// format the page's Clip markup gives Google), and the current chapter highlighted while it plays.
// It talks to the player through YouTube's postMessage interface (the iframe has enablejsapi=1).
(function () {
  var frame = document.getElementById('watch-player-frame');
  if (!frame) return;
  var ORIGIN = 'https://www.youtube.com';
  var links = document.querySelectorAll('.w-ch');
  var start = parseInt(new URLSearchParams(location.search).get('t') || '0', 10) || 0;
  window.__watchTime = null; // last time reported by the player, read by the screenshot check

  function mark(t) {
    var cur = null;
    links.forEach(function (a) { if (parseInt(a.getAttribute('data-t'), 10) <= t) cur = a; });
    links.forEach(function (a) { if (a === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
  }

  function send(func, args) {
    frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: args || [] }), ORIGIN);
  }

  // A deep link from a key moment: start the player there. The src changes once, before anyone has pressed play.
  if (start > 0) {
    frame.src = frame.src.replace(/&start=\d+/, '') + '&start=' + start;
    mark(start);
  }

  // Ask the player to report its state, so the chapter list can follow along.
  frame.addEventListener('load', function () {
    frame.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: frame.id, channel: 'widget' }), ORIGIN);
  });
  window.addEventListener('message', function (ev) {
    if (ev.origin !== ORIGIN || typeof ev.data !== 'string') return;
    try {
      var d = JSON.parse(ev.data);
      if (d.info && typeof d.info.currentTime === 'number') {
        window.__watchTime = d.info.currentTime;
        if (d.info.currentTime > 0.5) mark(Math.floor(d.info.currentTime)); // no highlight before anyone presses play
      }
    } catch (e) { /* not ours */ }
  });

  document.querySelectorAll('[data-t]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      ev.preventDefault();
      var t = parseInt(a.getAttribute('data-t'), 10);
      history.replaceState(null, '', t ? '?t=' + t : location.pathname);
      mark(t);
      send('seekTo', [t, true]);
      send('playVideo');
      var r = frame.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) frame.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();
